import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaPrestacaoContasAnual: ['exercicio'],
    setAdministracoesConsultaPrestacaoContasAnual: ['administracoes'],
    limpaFiltroConsultaPrestacaoContasAnual: [],
    receberFiltroConsultaPrestacaoContasAnual: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracoes: [],
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracoes = (state = INITIAL_STATE, action) => {
    return { ...state, administracoes: action.administracoes }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_PRESTACAO_CONTAS_ANUAL]: setExercicio,
    [Types.SET_ADMINISTRACOES_CONSULTA_PRESTACAO_CONTAS_ANUAL]: setAdministracoes,
    [Types.LIMPA_FILTRO_CONSULTA_PRESTACAO_CONTAS_ANUAL]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_PRESTACAO_CONTAS_ANUAL]: receberFiltro,
})
